
import { SEARCH_BY, PATIENT_TIMESPAN } from "../config/config.js";
import { ie, ios, safari } from "../helpers/browserDetect";
import moment from "moment";

let modernizr = window.Modernizr;

export default {
  // window width, in pixels
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  isFullscreen: false,

  isOpenedInApp: window.isOpenedInApp,
  isIE: ie,
  isIOS: ios,
  isSafari: safari,
  hasWebgl: modernizr.webgl,
  webglMaxTexture: (function(){
    let temp = document.createElement("canvas");
    let gl = temp.getContext( "experimental-webgl" );
    let maxTexture = 0;
    if(gl){
      maxTexture = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }
    return maxTexture;
  })(),

  auth: null,
  userPrefs: {
    fullscreen: null,
    patientDateSetting: null,
    defaultColorTheme: null,
    pageSize: null,
    autoPatientExamRefresh: null,
    defaultHVF: null,
    defaultCirrusView: null,
    defaultHVFview: null
  },
  mfa: {
    enabled: false,
    secret: null
  },
  // isIdle = true => the user hasn't interacted with the site recently
  isIdle: false,
  disableAutoLogout: false,
  backgroundTimestamp: 0,

  // currently shown status
  status: {
    message: null,
    level: null,
    timeout: 5000
  },
  // status to show in the next page
  delayedStatus: null,

  // details about the site
  siteInfo: { axisTitle: "" },
  isActDirEnabled: null,
  userList: [],
  knowledgeCenterSettings: {},
  videoLibrary: [],
  knowledgeCenterVideoSrc: null,
  bestPracticesEntries: [],

  // physicians list for DDLs
  physicians: [],
  // devices list for DDLs
  devices: [],
  deviceLogs: [],
  // device types list for DDLs
  devTypes: [],
  // device location list for DDLs
  devLocations: [],
  // procedures list for DDLs
  procedures: [],

  patientSearch: {
    timespan: PATIENT_TIMESPAN.today,
    searchBy: SEARCH_BY.DateIntervals,
    dateStart: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateEnd: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    keyword: "",
    advancedSearch: null
  },
  patientSearchOptions: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["ptId"],
    sortDesc: [false],
    groupBy: ["exDateIso"],
    groupDesc: [true]
  },
  ssoSearch: null,
  wasEmrPro: false,
  emrProSearchParams: null,
  advancedSearchDialog: false,
  loadingPatients: false,
  patients: [],
  totalPatients: -1,
  // currently selected patient
  patient: null,
  loadingExams: false,
  exams: [],
  selectedExams: [],
  // currently selected exam
  exam: null,
  examToDelete: null,
  examToDownload: null,
  // containers for deleting/downloading multiple exams at once
  examsToDelete: [],
  examToEdit: null,

  imageBrowserContext: null,

  imageMap: [],
  imageQueue: null,

  imageOrder: [],

  octImageMap: [],
  octFullQueue: null,
  octSegmentationQueue: null,

  i2kImages: [],

  patientExamMultiviewContext: null,
  patientExamMultiviewSelectAll: false,

  proofsheetContext: null,

  stereoContext: null,
  sideBySideContext: null,
  printPreviewContext: null,

  overlayContext: null,
  originalOverlaySettings: null,
  loadingMessage: null,

  activeDownload: {
    link: null,
    text: null
  },

  textAnnotationToEdit: null,

  shapeOutlineContext: null,
  shapeOutlineSyncContext: null,

  shapeFillContext: null,
  shapeFillSyncContext: null,

  placeholderContext: null,

  // stack of open fullscreen browsers
  browserStack: [],
  // array of exams opened in the patient detail table
  openedExams: [],

  showHelpDialog: false,

  videoViewer: null,

  selectedAppPrintImages: null,
  isLoadingAppPrintImages: false,

  showDeepDeeDialog: false,

  calledFullscreenToggle: false
};
